import Axios from '../Axios';

const user = {
	create(data) {
		return Axios.post('/users', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/users?active=1&limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/users/' + id);
	},
	update(id, data) {
		return Axios.put('/users/' + id, data);
	},
	delete(id) {
		return Axios.delete('/users/' + id);
	},
};

export default user;
